(function() {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.nocturne-reveal').forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }

  if (window.Shopify && window.Shopify.designMode) {
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -60px 0px'
  });

  function initReveal() {
    var els = document.querySelectorAll('.nocturne-reveal');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].classList.contains('is-visible')) {
        observer.observe(els[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector('.nocturne')) {
      initReveal();
    }
  });
})();
